import React, { useState } from "react";
import "../Style/Clientfeedback.css";
import avatarIcon from "../assets/avatar.png";
import reactionIcon from "../assets/reaction.png";

const feedbacks = [
  {
    name: "Priya Sharma",
    handle: "@BrightNest",
    message:
      "The new website gave our brand a completely fresh identity. The design feels premium, and customer inquiries have noticeably increased.",
    reply:
      "Thank you, Priya!\nWe're thrilled the new experience is helping your business attract more customers.",
  },
  {
    name: "Rahul Mehta",
    handle: "@UrbanBuild",
    message:
      "Professional, responsive, and detail-oriented. The team delivered exactly what was promised and even suggested improvements we hadn't considered.",
    reply:
      "Appreciate the kind words, Rahul!\nIt was a pleasure collaborating and bringing your vision to life.",
  },
  {
    name: "Sneha Reddy",
    handle: "@EcoLiving",
    message:
      "Our website now loads much faster and looks fantastic on mobile devices. The entire process was smooth from start to finish.",
    reply:
      "Thanks, Sneha!\nWe're glad the performance and mobile experience are making a difference.",
  },
  {
    name: "Vikram Patel",
    handle: "@NextGenTech",
    message:
      "Exceptional work on both design and development. The attention to user experience has significantly improved engagement on our site.",
    reply:
      "Thank you, Vikram!\nCreating intuitive user experiences is always our top priority.",
  },
  {
    name: "Ananya Iyer",
    handle: "@CraftHouse",
    message:
      "From concept to launch, everything was handled professionally. The final website perfectly reflects our brand personality.",
    reply:
      "We're grateful for your feedback, Ananya!\nSeeing your brand shine online is exactly what we aim for.",
  },
  {
    name: "Karan Verma",
    handle: "@ScaleWorks",
    message:
      "The communication throughout the project was excellent. Every milestone was delivered on time, and the quality exceeded expectations.",
    reply:
      "Thank you, Karan!\nClear communication and quality delivery are what we strive for every project.",
  },
];

const columns = [
  [feedbacks[0], feedbacks[3], feedbacks[1], feedbacks[5]],
  [feedbacks[2], feedbacks[5], feedbacks[4], feedbacks[0]],
  [feedbacks[1], feedbacks[4], feedbacks[0], feedbacks[3]],
];

const FeedbackCard = ({ feedback }) => (
  <article className="cf-card">
    <p className="cf-card-name">{feedback.name}</p>

    <div className="cf-bubble cf-bubble-left">
      <p className="cf-bubble-text">{feedback.message}</p>
    </div>

    <div className="cf-reaction-wrap">
      <img src={reactionIcon} alt="reaction" className="cf-reaction-img" />
    </div>

    <div className="cf-bubble cf-bubble-right">
      <p className="cf-bubble-text" style={{ whiteSpace: "pre-line" }}>
        {feedback.reply}
      </p>
    </div>

    <div className="cf-footer">
      <img src={avatarIcon} alt={feedback.name} className="cf-avatar" />
      <div className="cf-footer-info">
        <span className="cf-footer-name">{feedback.name}</span>
        <span className="cf-footer-handle">{feedback.handle}</span>
      </div>
    </div>
  </article>
);

const ClientFeedback = () => {
  const [current, setCurrent] = useState(0);
  const total = feedbacks.length;

  const goPrev = () => setCurrent((prev) => (prev - 1 + total) % total);
  const goNext = () => setCurrent((prev) => (prev + 1) % total);

  return (
    <section className="cf-section">
      <div className="cf-shell">
        <div className="cf-copy">
          <span className="cf-eyebrow">Client Stories</span>
          <h2 className="cf-heading">Client Feedback!</h2>
          <p className="cf-quote">
            "Every great product starts as a thought. We help that thought grow,
            evolve, and turn into something people actually love to use."
          </p>
        </div>

        {/* ── Desktop / tablet-landscape marquee (hidden ≤768px) ── */}
        <div className="cf-marquee-grid" aria-label="Client feedback marquee">
          {columns.map((column, columnIndex) => {
            const loopItems = [...column, ...column];

            return (
              <div
                className={`cf-marquee-column ${
                  columnIndex === 1
                    ? "cf-marquee-column--down"
                    : "cf-marquee-column--up"
                }`}
                key={columnIndex}
              >
                <div className="cf-marquee-track">
                  {loopItems.map((feedback, index) => (
                    <FeedbackCard
                      feedback={feedback}
                      key={`${columnIndex}-${feedback.handle}-${index}`}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* ── Mobile carousel with arrows (shown ≤768px) ── */}
        <div className="cf-carousel" aria-label="Client feedback carousel">
          <button
            type="button"
            className="cf-arrow cf-arrow-prev"
            onClick={goPrev}
            aria-label="Previous feedback"
          >
            <span aria-hidden="true">&#8249;</span>
          </button>

          <div className="cf-carousel-track">
            <FeedbackCard feedback={feedbacks[current]} />
          </div>

          <button
            type="button"
            className="cf-arrow cf-arrow-next"
            onClick={goNext}
            aria-label="Next feedback"
          >
            <span aria-hidden="true">&#8250;</span>
          </button>
        </div>

        <div className="cf-dots" aria-hidden="true">
          {feedbacks.map((feedback, index) => (
            <span
              key={feedback.handle}
              className={`cf-dot ${index === current ? "cf-dot--active" : ""}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientFeedback;